/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartReferenceLine = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M14.999 7v14H9V7zm7 6v8H16v-8zM8 10v11H2V10zm12 5h-2v4.001h2zm-7-6h-2v10h2zm-7 3H4v7h2zM5 3v2H3V3zm4 0v2H7V3zm4 0v2h-2V3zm4.001 0v2H15V3zM21 3v2h-2V3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartReferenceLine as ChartReferenceLine };
